import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const productContentUrl = "/api/v2/productcontent";

export interface ProductDataPointResultModel {
    result?: string;
}

export interface ProductDataPointParams extends ApiParameter {
    productNumber?: string;
}

export async function getProductContent(parameter: ProductDataPointParams) {
    const response = await get<string>(`${productContentUrl}/${parameter.productNumber}`);
    return response;
}
